import RiskLevel from './RiskLevel/RiskLevel';
import styles from './MifidRelatedData.module.css';
import Category from './Category/Category';
import AppropriatenessTest from './AppropriatenessTest/AppropriatenessTest';

function MifidRelatedData() {

  return (
    <>
      <RiskLevel />
      <div className={styles.border} />
      <Category />
      <div className={styles.border} />
      <AppropriatenessTest />
    </>
  );
}

export default MifidRelatedData;
